import getIn from 'immutable-less/transmute/getIn';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
// @ts-expect-error untyped module reference-resolvers
import { SALESFORCE_CAMPAIGN } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module reference-resolvers
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped module reference-resolvers
import { isError, isResolved } from 'reference-resolvers/utils';
import ErrorLabel from 'automation-ui-core/components/ErrorLabel';
import * as CreateSalesforceCampaignActionMetadataKeys from 'automation-ui-action-features/actions/create-salesforce-campaign/CreateSalesforceCampaignActionMetadataKeys';

// @ts-expect-error untyped module reference-resolvers

import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreateSalesforceCampaignActionDetailView = ({
  actionMetadata,
  campaign,
  messageLangPath = 'actionDetail'
}) => {
  const campaignId = actionMetadata[CreateSalesforceCampaignActionMetadataKeys.CAMPAIGN_ID];
  if (!campaign || !campaignId || isError(campaign)) {
    const hasApiLimitError = getIn(['reason', 'errorType'], campaign) === 'HUBSPOT_API_LIMIT_EXCEEDED';
    if (hasApiLimitError) {
      return /*#__PURE__*/_jsx(ErrorLabel, {
        children: getIn(['reason', 'humanizedMessage'], campaign)
      });
    }
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "campaign"
    });
  }
  const label = isResolved(campaign) ? getIn(['label'], campaign) : campaignId;
  const status = actionMetadata[CreateSalesforceCampaignActionMetadataKeys.STATUS] || /*#__PURE__*/_jsx(MissingLabel, {
    type: "status"
  });
  const options = {
    campaignId: /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: label
    }),
    status: /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: status
    })
  };
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-salesforce-campaign.action-detail",
    options: options
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-salesforce-campaign.action-preview",
    options: options
  });
};
const mapResolversToProps = (resolvers, props) => {
  const selectedCampaignId = props.actionMetadata[CreateSalesforceCampaignActionMetadataKeys.CAMPAIGN_ID];
  return {
    campaign: resolvers[SALESFORCE_CAMPAIGN].byId(selectedCampaignId)
  };
};
const CreateSalesforceCampaignActionDetail = ResolveReferences(mapResolversToProps)(CreateSalesforceCampaignActionDetailView);
export default CreateSalesforceCampaignActionDetail;